import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateBunnySettingsMutation } from "../graphql/mutations";
import type {
  UpdateBunnySettingsMutationType,
  UpdateBunnySettingsMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateBunnySettingsMutation = (
  options?: MutationHookOptions<
    UpdateBunnySettingsMutationType,
    UpdateBunnySettingsMutationVariablesType
  >
) => {
  return useMutation<
    UpdateBunnySettingsMutationType,
    UpdateBunnySettingsMutationVariablesType
  >(UpdateBunnySettingsMutation, options);
};
